// extracted by mini-css-extract-plugin
export default {"root":"PersonCard_root__VX0sZ","content":"PersonCard_content__EHHgA","testimonial":"PersonCard_testimonial__cDh+Z","person-info":"PersonCard_person-info__swyg9"};